import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Button } from '@interxfi/design-system/components/button/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table';
import PlusIcon from '@interxfi/design-system/icons/react/icon-plus';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { SweepsJobCreateDrawer } from '../../../../../../../../../../features/sweeps/clearing/job/sweeps-job-create-drawer';
import { SweepsJobsTable } from '../../../../../../../../../../features/sweeps/clearing/job/sweeps-jobs-table';
import { useCanCreateSweepsJob } from '../../../../../../../../../../features/sweeps/sweeps-permission-helpers';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/sweep/job/_job/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingOperationsSweeps,
      label: 'Jobs',
      order: 2,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingOperationsSweeps>,
  head: () => getPageHead('Sweep Jobs'),
  component: SweepJobList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  const canCreateSweepsJob = useCanCreateSweepsJob();

  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          {canCreateSweepsJob ? (
            <RequiresAccess write>
              <SweepsJobCreateDrawer trigger={<Button affixIcon={<PlusIcon aria-hidden />} aria-label="New Sweep Job" size="small" />} />
            </RequiresAccess>
          ) : null}
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingOperationsSweeps}
    />
  );
}

function SweepJobList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <SweepsJobsTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
